// js/utils/constants/general_constants.js
/* jshint esversion: 6 */
"use strict";

// API endpoints
export const API_BASE_URL = 'https://adadimall.com/api/';
export const USER_ENDPOINT = `${API_BASE_URL}/users`;
export const POSTS_ENDPOINT = `${API_BASE_URL}/posts`;

// Action types
export const ACTION_TYPE_LOGIN = 'LOGIN';
export const ACTION_TYPE_LOGOUT = 'LOGOUT';
export const ACTION_TYPE_FETCH_USERS = 'FETCH_USERS';

// Miscellaneous
export const DEFAULT_LANGUAGE = 'id';
export const SUPPORTED_LANGUAGES = ['en', 'id'];

//appname
export const PARTNERSHIP_APP = 'partnership';

// Url
export const DEFAULT_LANGUAGE_URL = `/${DEFAULT_LANGUAGE}/`;
export const HOME_URL = DEFAULT_LANGUAGE_URL;
export const MAIN_LOGIN_URL = `${DEFAULT_LANGUAGE_URL}main_login/`;
export const MAIN_LOGOUT_URL = `${DEFAULT_LANGUAGE_URL}log_out/`;
export const ABOUT_US_URL = `${DEFAULT_LANGUAGE_URL}about_us/`;
export const UNSUBSCRIBE_INVITATION_URL = key => `${DEFAULT_LANGUAGE_URL}ref_email/unsubcribe_invitation/${key}/`;
export const COLLAB_URL = `${DEFAULT_LANGUAGE_URL}${PARTNERSHIP_APP}/collab/`;
export const INFLUENCER_GROUPING_URL = `${DEFAULT_LANGUAGE_URL}${PARTNERSHIP_APP}/influencer_grouping/`;